module.exports = __webpack_public_path__ + "img/M4_JKKP_02.1316d8ec.png";